/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorAdventureTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorAdventure,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Explore the Great Outdoors!",
    "Adventure Awaits in Nature!",
    "Get Ready for Some Fun!",
  ],
  title: "Outdoor Adventure",
  description: "Organize a fun outdoor adventure.",
  longDescription:
    "Gather your friends for an exciting outdoor adventure! Choose a date, decide on activities, and plan gear needed for the day!",
  emoji: "🏞",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Adventure",
          emoji: "🏞",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the outdoor adventure?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to do?",
            description: "What activities should we include in our adventure?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we choose?",
                emoji: "🚴",
                completeAction: {
                  question: "Decide on gear needed?",
                  description: "What gear should we prepare for the adventure?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What gear should we bring?",
                      emoji: "🎒",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Adventure!",
    outroDescription: "Your outdoor adventure plans are set! Enjoy exploring!",
  },
};
